export enum StatusType {
  Absence = "ABSENCE",
  Active = "ACTIVE",
  Pending = "PENDING",
  Suspended = "SUSPENDED",
  Terminated = "TERMINATED"
}
